import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation reorderHappeningsMutation($input: ReorderHeroOffersInput!) {
    reorderHeroOffers(input: $input) {
      lists {
        ...HappeningsContainer_lists
      }
    }
  }
`;

const reorderHappenings = (environment, ids, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: { ids },
    },
    ...args,
  });
};

export default reorderHappenings;
